import React from 'react'
import cx from 'classnames'
import SubmitEmailPreviewBox from './components/SubmitEmailPreviewBox'

import style from './style.styl'

const toHex = colorCode => `#${colorCode}`

const EmailCapturePreview = ({ name, message, avatarUrl, backgroundColor, className }) => (
  <div className={cx(style.EmailCapturePreview, className)}>
    <div className="capture-message">
      <span className="name">{name}</span>
      <div className="content">{message}</div>
    </div>

    <div className="submit-email-wrapper">
      <div className="avatar">
        <div className="avatar-image" style={{ backgroundImage: `url(${avatarUrl})` }} />
      </div>
      <SubmitEmailPreviewBox backgroundColor={toHex(backgroundColor)} />
    </div>
  </div>
)

export default EmailCapturePreview



// WEBPACK FOOTER //
// ./src/scripts/components/settings/ChatWidget/components/EmailCapturePreview/index.js